import { formatNum } from "./format";

export const formatPnl = (pnl: number) => {
  return pnl
    ? formatNum(pnl, {
        dp: 2,
        prefix: pnl > 0 ? "+$" : "-$",
      })
    : "Not yet";
};

export const formatScore = (score: number) => {
  return score
    ? formatNum(score, {
        dp: 2,
        prefix: score > 0 ? "+" : "",
      })
    : "Not yet";
};
